function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "jewellery_svg__cls-3",
  d: "M66.27 118.46c-22.33 0-40.5-18.17-40.5-40.5s18.17-40.5 40.5-40.5 40.5 18.17 40.5 40.5-18.17 40.5-40.5 40.5zm0-76c-19.58 0-35.5 15.93-35.5 35.5s15.93 35.5 35.5 35.5 35.5-15.93 35.5-35.5-15.93-35.5-35.5-35.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "jewellery_svg__cls-3",
  d: "M68.16 40.12h-5.23L50.91 22.8l8.2-8.72h14.31l8.29 8.82-13.55 17.23zm-2.61-5h.18l9.39-11.94-3.86-4.11h-9.99l-3.95 4.2 8.22 11.84z"
});

function SvgJewellery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "jewellery_svg__Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.54 132.54",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3);
}

export default SvgJewellery;